//@flow strict
import React from 'react';

type Props = {
  label?:string,
  className?:string,
  buttonId?:string,
  renderMarkup:boolean,
  action:?() => mixed,
  children?:React$Node,
  onFocus?:() => void,
  onMouseEnter?:MouseEventHandler,
  onMouseDown?:MouseEventHandler,
};

export default class AccessibleButtonWrapper extends React.Component<Props> {
  static defaultProps = {
    renderMarkup: false,
  }

  handleKeyDown = (event:KeyboardEvent) => {
    if (event.keyCode === 13 || event.keyCode === 32) {
      event.preventDefault();
      this.props.action && this.props.action();
    }
  }

  handleClick = () => {
    this.props.action && this.props.action();
  }

  render() {
    const spanProps = {
      tabIndex: "0",
      role: "button",
      id: this.props.buttonId || "",
      'aria-label': this.props.label,
      className: this.props.className,
      onClick: this.handleClick,
      onKeyDown: this.handleKeyDown,
      onMouseDown: this.props.onMouseDown,
      onMouseEnter: this.props.onMouseEnter,
    };
    if (this.props.renderMarkup) {
      return (
        <span
          {...spanProps}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{__html: this.props.children}}
        />
      );
    }
    return (
      <span {...spanProps} >
        {this.props.children}
      </span>
    );
  }
}
